import APPCONFIG from '../../constants/Config';
import {
  REINIT_STATE,
  GET_COMPANIES,
  GET_COMPANIES_SUCCESS,
  GET_COMPANIES_ERROR,
  ADD_COMPANY_SET_PARENT,
  ADD_COMPANY,
  ADD_COMPANY_SUCCESS,
  ADD_COMPANY_ERROR,
  DELETE_COMPANY,
  DELETE_COMPANY_SUCCESS,
  DELETE_COMPANY_ERROR,
  GET_COMPANY,
  GET_COMPANY_SUCCESS,
  GET_COMPANY_ERROR,
  UPDATE_COMPANY,
  UPDATE_COMPANY_SUCCESS,
  UPDATE_COMPANY_ERROR,
} from '../../constants/ActionTypes';
import { flatMapDeepFromKey } from '../../utils/Tools';
// Model
/* eslint-disable import/named */
import { deserialize } from '../../models/company';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.company;
const company = (state = initialSettings, action) => {
  let key;
  switch (action.type) {
    // REINIT STATE
    case REINIT_STATE:
      key = null;
      if (action.target === 'fullCompany') {
        return {
          ...state,
          current: { ...initialSettings.current },
          add: { ...initialSettings.add },
          update: { ...initialSettings.update },
          delete: { ...initialSettings.delete },
        };
      }
      switch (action.target) {
        case 'currentCompany':
          key = 'current';
          break;
        case 'addCompany':
          key = 'add';
          break;
        case 'updateCompany':
          key = 'update';
          break;
        default:
          break;
      }
      if (key) {
        return {
          ...state,
          [key]: {
            ...initialSettings[key],
          },
        };
      }
      return state;
    // GET COMPANIES
    case GET_COMPANIES:
      return {
        ...state,
        list: {
          ...state.list,
          error: null,
          loading: true,
          elements: null,
          flattenElements: null,
        },
      };
    case GET_COMPANIES_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          error: action.error,
          loading: false,
        },
      };
    case GET_COMPANIES_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          elements: deserialize(action.data.data),
          flattenElements: flatMapDeepFromKey(deserialize(action.data.data), 'children'),
          loading: false,
        },
      };
    // ADD COMPANY
    case ADD_COMPANY_SET_PARENT:
      return {
        ...state,
        add: {
          ...state.add,
          parent: action.company,
        },
      };
    case ADD_COMPANY:
      return {
        ...state,
        add: {
          ...state.add,
          added: false,
          error: null,
        },
      };
    case ADD_COMPANY_ERROR:
      return {
        ...state,
        add: {
          ...state.add,
          error: action.error,
        },
      };
    case ADD_COMPANY_SUCCESS:
      return {
        ...state,
        add: {
          ...state.add,
          added: true,
        },
      };
    // DELETE COMPANY
    case DELETE_COMPANY:
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: false,
          error: null,
        },
      };
    case DELETE_COMPANY_ERROR:
      return {
        ...state,
        delete: {
          ...state.delete,
          error: action.error,
        },
      };
    case DELETE_COMPANY_SUCCESS:
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: true,
        },
      };
    // GET
    case GET_COMPANY:
      return {
        ...state,
        current: {
          ...state.current,
          loading: true,
          data: null,
          error: null,
        },
      };
    case GET_COMPANY_ERROR:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          error: action.error,
        },
      };
    case GET_COMPANY_SUCCESS:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          data: deserialize(action.data.data),
        },
      };
    // UPDATE
    case UPDATE_COMPANY:
      return {
        ...state,
        update: {
          ...state.update,
          error: null,
          updated: false,
        },
      };
    case UPDATE_COMPANY_ERROR:
      return {
        ...state,
        update: {
          ...state.update,
          error: action.error,
        },
      };
    case UPDATE_COMPANY_SUCCESS:
      return {
        ...state,
        update: {
          ...state.update,
          updated: true,
        },
      };
    default:
      return state;
  }
};

export default company;



// WEBPACK FOOTER //
// ./reducers/company/company.js